import React from 'react';
import {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import './App.css';
import Home from './Home';
import Category from './Category';
import TransactionRiskEngineDetails from './TransactionRiskEngineDetails';

class ScrollToTopBase extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

const ScrollToTop = withRouter(ScrollToTopBase);

class App extends Component {
  state = {  }
  render() { 
    return ( 
    <Router>
      <ScrollToTop />
      <Switch>
        <Route path = '/' exact={true} component={Home}/>
        <Route path = '/categories' exact={true} component={Category}/>
        <Route path = '/Transaction-Risk-Engine' exact={true} component={TransactionRiskEngineDetails}/>
      </Switch>
    </Router>
     );
  }
}

export default App;
